export const ENDPOINTS = {
    CONTACT_FORM: 'https://api.elystrion.com/mkt/api/MarketingPage/contact-us', // Replace with your actual endpoint
    PUBLIC_BLOCKCHAIN_DETAILS: `https://catenaa-jv-apim-dev.azure-api.net/bc/api/RegistrationManagement/verify-block-chain`
};